import type React from "react"
import type { AppIconProps, IconProp } from "./AppIcons"
import { AppIcons } from "./AppIcons"

export const DEFAULT_SIZE = 16

/**
 * Take either an IconComponent or an IconKey and render it as a component.
 */

export function renderIconFromIconProp(
  Icon: IconProp | null | undefined,
  props?: AppIconProps,
) {
  if (typeof Icon === "string") {
    const Component = AppIcons[Icon]
    return <Component size={DEFAULT_SIZE} {...props} />
  }
  if (typeof Icon === "function") {
    return <Icon size={DEFAULT_SIZE} {...props} />
  }
  return Icon ?? null
}
